import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

type SignatureCanvasRef = SignatureCanvas & {
  getCanvas(): HTMLCanvasElement;
};

const SignaturePad: React.FC<{ onChange: (dataUrl: string) => void }> = ({ onChange }) => {
  const sigCanvas = useRef<SignatureCanvasRef | null>(null);

  const clear = () => {
    sigCanvas.current?.clear();
    onChange("");
  };

  const save = () => {
    if (!sigCanvas.current) return;

    const canvas = sigCanvas.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");
    onChange(dataUrl);
  };

  return (
    <div>
      <SignatureCanvas
        ref={sigCanvas}
        penColor="black"
        canvasProps={{ width: 400, height: 200, className: "border" }}
        onEnd={save} // auto-save when drawing ends
      />
      <div className="mt-2 flex gap-2">
        <button type="button" onClick={clear}>Clear</button>
        <button type="button" onClick={save}>Save</button>
      </div>
    </div>
  );
};

export default SignaturePad;